import { FC, SVGProps } from 'react';

const TrainingIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M9.1165 11.9739L3.41473 9.18704C2.19523 8.59104 2.19523 6.85342 3.41392 6.25745L8.86033 3.59547C9.57467 3.24601 10.4098 3.24601 11.1242 3.59547L16.577 6.25988C17.7965 6.85585 17.7965 8.59429 16.577 9.19021L11.1266 11.8539C10.4098 12.2041 9.57225 12.2041 8.85542 11.8539L5.39317 10.1616"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.4998 7.71643L17.4722 12.228"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.39404 10.1611V14.3036C5.39404 15.0172 5.81729 15.674 6.47651 15.9464C8.78899 16.9008 11.0918 16.913 13.3857 15.952C14.04 15.678 14.4592 15.0229 14.4592 14.3134V10.2365"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TrainingIcon;
